import DateTime from './DateTime.vue';

export default DateTime;
